
import React from "react";
import { Agent } from "@/models/agent";
import AgentCard from "@/components/agent-card";

interface AgentGridProps {
  agents: Agent[];
}

const AgentGrid: React.FC<AgentGridProps> = ({ agents }) => {
  if (agents.length === 0) {
    return (
      <div className="text-center py-12">
        <h3 className="text-xl font-medium mb-2">No agents found</h3>
        <p className="text-muted-foreground">Try adjusting your search or filters.</p>
      </div>
    );
  }

  // Process the agent data to match the expected format for AgentCard
  const processedAgents = agents.map(agent => ({
    id: agent.id,
    name: agent.name,
    description: agent.description,
    category: agent.category,
    imageUrl: "/placeholder.svg", // You can update this when you have actual images
    author: agent.owner_id.substring(0, 8), // Display shortened user ID for now
    downloads: agent.downloads || 0,
    rating: 4.5, // Default rating
    isPremium: agent.pricingModel !== "free",
    price: agent.pricingModel === "free" ? "Free" : 10,
    creator: {
      name: agent.owner_id.substring(0, 8),
      avatar: "/placeholder.svg"
    }
  }));

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {processedAgents.map((agent) => (
        <AgentCard key={agent.id} agent={agent} />
      ))}
    </div>
  );
};

export default AgentGrid;
